import axios from "axios";
import { getBaseDomainFromApiUrl } from "./helpers/domainHelper";

export var Config = (function () {
  let domain = "";
  let logoId = "";
  let baseDomain = "";
  let messageErrorCommunication = "";
  let language = "en";
  let license = {
    domains: "",
    expiryDate: "",
    key: "",
  };
  let InIframe = true;
  let messageParent = false;
  let faceTecOperations = {
    liveness: "liveness-3d",
    enrollment: "enrollment-3d",
    auth: "match-3d-3d",
  };

  if (typeof window !== "undefined") {
    InIframe = window.self !== window.top;
    const params = new URLSearchParams(location.search);
    const paramLogo = params.get("logo");
    messageParent = !!params.get("messageParent");
    faceTecOperations = {
      liveness: params.get("livenessOp") || "liveness-3d",
      enrollment: params.get("enrollmentOp") || "enrollment-3d",
      auth: params.get("authOp") || "match-3d-3d",
    };

    baseDomain = process.env.API_SERVER;

    // Extract domain for backward compatibility
    try {
      const url = new URL(baseDomain);
      domain = url.hostname
        .replace(".maatai.com", "")
        .replace("localhost", "local");
    } catch {
      domain = "dev";
    }

    if (paramLogo != "" && paramLogo != "null") {
      logoId = paramLogo;
    }
    fetchDate();
    fetchKey();
    language = window.navigator.language.includes("es") ? "es" : "en";

    messageErrorCommunication =
      language == "en"
        ? "A failed conection has been found. \n" +
          "Please close this tab and follow the instructions of the previous one."
        : "Se ha registrado una desconección con tu aplicación. \n" +
          "Por favor cierra esta pestaña y sigue las instrucciones indicadas en la ventana anterior.";

    async function fetchDate() {
      try {
        const { data } = await axios.get(
          `${baseDomain}/api/v3/setting/get?key=face_tec_license_expiration_date`,
        );
        license["expiryDate"] = data.data.setting.Value;
      } catch (error) {
        console.log("=== ERROR ===");
        console.log(error);
      }
    }

    async function fetchKey() {
      try {
        const { data } = await axios.get(
          `${baseDomain}/api/v3/setting/get?key=face_tec_license_key`,
        );
        license["key"] = data.data.setting.Value;
      } catch (error) {
        console.log("=== ERROR ===");
        console.log(error);
      }
    }
  }

  // -------------------------------------
  // REQUIRED
  // Available at https://dev.facetec.com/#/account
  // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
  // var DeviceKeyIdentifier = "dQJlT4NZW8zHfKwe105g0rjcnz5Mzfox";
  var DeviceKeyIdentifier = "dnTDuwQzkgM5F1IeW6AMFOLOwPWf18p7";

  // -------------------------------------
  // REQUIRED
  // The URL to call to process FaceTec SDK Sessions.
  // In Production, you likely will handle network requests elsewhere and without the use of this variable.
  // See https://dev.facetec.com/#/security-best-practices?link=zoom-server-rest-endpoint-security for more information.
  // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
  var BaseURL = baseDomain + "/api/v2/lifetest/faceteck/session";

  // -------------------------------------
  // REQUIRED
  // The FaceMap Encryption Key you define for your application.
  // Please see https://dev.facetec.com/#/licensing-and-encryption-keys for more information.
  // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
  var PublicFaceScanEncryptionKey =
    "-----BEGIN PUBLIC KEY-----\n" +
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApLxD1I/iveli8m5qZAy3\n" +
    "4qDyqcw1FghRv6rTrmFUYVfQNvjDRj6MOkmZpJg39jhNTLXJCAKt+YKFSBNfXy67\n" +
    "T+3zl0q1DzXf81OYyL5SWeizshJyDEVRtc7WNLJKInFPDYmTwUmTdHa8WcJK9mYi\n" +
    "jQpupVP7c+lFfa/YJKMUyvRVh0DrgR4Hv9gdQNBefxmv1QipT3q5fQH1jvSl9pMF\n" +
    "mHlzI2jw8NjwX1dIcg1ftquNyetJRZs/mlaR0fLzryp29N19qR3tjkwIpoMFFoVi\n" +
    "/l2ELpip2YhSKnz9R5+ojpa8sYVD9Hx9vFaGzGPT/wj91iQO++GP2mM9pgiPD+S+\n" +
    "yQIDAQAB\n" +
    "-----END PUBLIC KEY-----";

  // FaceTec SDK Version from environment variable
  var FaceTecVersion = process.env.FACETEC_VERSION || "9.6";

  return {
    DeviceKeyIdentifier,
    BaseURL,
    PublicFaceScanEncryptionKey,
    license,
    logoId,
    messageErrorCommunication,
    language,
    domain,
    baseDomain,
    InIframe,
    messageParent,
    FaceTecVersion,
    faceTecOperations,
  };
})();
